var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateGet = (obj, member, getter) => {
  __accessCheck(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateSet = (obj, member, value, setter) => {
  __accessCheck(obj, member, "write to private field");
  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};
const isNative = (element) => element instanceof HTMLInputElement || element instanceof HTMLTextAreaElement;
function FormControlMixin(constructor) {
  var _formControlElement;
  class FormControl extends constructor {
    constructor() {
      super(...arguments);
      /**
       * The actual element that integrates with the form; either
       * a Form Associated Custom Element, or an `<input>` or `<textarea>`.
       */
      __privateAdd(this, _formControlElement, void 0);
    }
    get formControlElement() {
      if (__privateGet(this, _formControlElement)) {
        return __privateGet(this, _formControlElement);
      } else {
        throw new Error("A formControlElement must be set for the FormControlMixin to work");
      }
    }
    get form() {
      if (isNative(this.formControlElement)) {
        return this.formControlElement.form;
      } else {
        return this.formControlElement.internals.form;
      }
    }
    get labels() {
      if (isNative(this.formControlElement)) {
        return this.formControlElement.labels;
      } else {
        return this.formControlElement.internals.labels;
      }
    }
    shouldUpdate(changes) {
      return super.shouldUpdate(changes);
    }
    checkValidity() {
      if (isNative(this.formControlElement)) {
        return this.formControlElement.checkValidity();
      } else {
        return this.formControlElement.internals.checkValidity();
      }
    }
    reportValidity() {
      if (isNative(this.formControlElement)) {
        return this.formControlElement.reportValidity();
      } else {
        return this.formControlElement.internals.reportValidity();
      }
    }
    setFormControlElement(element) {
      __privateSet(this, _formControlElement, element);
    }
    setFormValue(value) {
      this.cachedValue = value;
      if (isNative(this.formControlElement)) {
        this.formControlElement.value = (value == null ? void 0 : value.toString()) ?? "";
      } else {
        this.formControlElement.internals.setFormValue(value ?? null);
      }
    }
  }
  _formControlElement = new WeakMap();
  return FormControl;
}
export {
  FormControlMixin
};
//# sourceMappingURL=form-control.js.map
